export const quizQuestions = [
  {
    id: "question16",
    videoId: "video16",
    topic: "TSMR",
    question: "A pavement arrow is an indication that:",
    options: [
      "A vehicle can go to the direction the arrow is pointing a",
      "A vehicle is prohibited to go in that direction",
      "Always follow the pavement arrow",
    ],
    correctAnswer: "A vehicle can go to the direction the arrow is pointing a",
    descriptionTitle: "BUS STOP Sign",
    description1:
      "A Bus Stop sign is a road traffic sign that indicates the location where buses are authorized to stop to pick up or drop off passengers. It serves as a designated point on the road where public transportation vehicles, such as buses, are expected to stop to allow passengers to board or disembark.",
  },
];
